import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators, State } from "@App/state";
import { useTranslation } from "react-i18next";
import { bindActionCreators } from "@reduxjs/toolkit";

export const useMileageStepDefinition = (onSubmit: () => void) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { setMileage } = bindActionCreators(actionCreators, dispatch);
  const mileage = useSelector((state: State) => state.orders.mileage);

  const [error, setError] = useState<string | null>("");

  const handleSubmit = (mileage: number) => {
    if (mileage <= 0) {
      setError(t("home.steps.mileage.errors.required"));
      return;
    }
    setError(null);
    setMileage(mileage);
    onSubmit();
  };

  return {
    mileage,
    onSubmit: handleSubmit,
    stepGoBackLinkTitle: mileage ? `${mileage} km` : "",
    error,
  };
};
